import { getSwimlanesLocalStorage } from '../localstorage/actions/getSwimlanesLocalStorage';
import { IKanbanViewState } from './types';
import {
    getNewCardsLocalStorage
} from '../localstorage/actions/getNewCardsLocalStorage';

export const getInitialState = (
): IKanbanViewState => {
    return {
        activityScrollListId: null,
        editedNameCardId: null,
        draggableCardId: null,
        moveToOpenedListId: null,
        snoozeBlockerClosed: false,
        highlightCardId: null,
        recentlyWatchCardId: null,
        scrollToActiveCardId: null,
        swimlanes: getSwimlanesLocalStorage(),
        newCards: getNewCardsLocalStorage(),
    };
}
